module.exports = __webpack_public_path__ + "static/media/rocket.0d17e457.png";